"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="calltoaction" className="bg-background py-32 flex items-center justify-center">
      <div ref={ref} className={cn("container mx-auto px-4 max-w-3xl flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        {}
        <Separator className="w-full max-w-[200px] mb-10 bg-border" />

        {}
        <h2 className="text-primary font-sans font-bold text-5xl leading-tight mb-10">
          Ready to Start Your Journey?
        </h2>

        {}
        <Button asChild className="bg-primary text-primary-foreground rounded-[4px] px-8 py-6 text-lg font-medium shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:bg-primary/90">
          <Link to="#">Get Started</Link>
        </Button>
      </div>
    </section>;
}